
export default (axiosError) => {

	const nu = new Date(Date.now()).toISOString();
	let errorTextHtml = '';

	if (axiosError.response)
	{
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
	//<br><b>Request:</b> ${JSON.stringify(axiosError.request)}
	//<br><b>Respons XMLHttpRequest:</b> ${JSON.stringify(axiosError.response.request)}
	//<br><b>Config:</b> ${JSON.stringify(axiosError.response.config)}
	//<br><b>Response headers:</b> ${JSON.stringify(axiosError.response.headers)}
	//<br><b>Response data:</b> ${axiosError.response.data}
		errorTextHtml = `
<p>Ett oväntat fel inträffade. Servern skickade status&shy;koden '${axiosError.response.status}&nbsp;${axiosError.response.statusText}'.</p>
<p>Försök igen om en stund. Om felet kvarstår så kontakta vår support.</p>
<p class="liten -morkgra-text">
	Interna uppgifter för felsökning:
	<br><b>Tidpunkt:</b> ${nu}
	<br><b>Felkod:</b> ${axiosError.code}
	<br><b>Felmeddelande:</b> ${axiosError.message}
</p>
`;
	}
	else if (axiosError.request)
	{
		// The request was made but no response was received
		// `axiosError.request` is an instance of XMLHttpRequest in the browser and an instance of
		// http.ClientRequest in node.js
	//<br><b>Request:</b> ${JSON.stringify(axiosError.request)}
		errorTextHtml = `
<p>Ett oväntat fel inträffade. Servern svarade inte.</p>
<p>Försök igen om en stund. Om felet kvarstår så kontakta vår support.</p>
<p class="liten -morkgra-text">
	Interna uppgifter för felsökning:
	<br><b>Tidpunkt:</b> ${nu}
	<br><b>Felkod:</b> ${axiosError.code}
	<br><b>Felmeddelande:</b> ${axiosError.message}
</p>
`;
	}
	else
	{
		// Something happened in setting up the request that triggered an Error
	//<br><b>Request:</b> ${JSON.stringify(axiosError.request)}
		errorTextHtml = `
<p>Ett oväntat internt fel inträffade.</p>
<p>Ladda om sidan med <span class='tangent'>Ctrl</span>+<span class='tangent'>F5</span> och försök igen. Om felet kvarstår så kontakta vår support.</p>
<p class="liten -morkgra-text">
	Interna uppgifter för felsökning:
	<br><b>Tidpunkt:</b> ${nu}
	<br><b>Felkod:</b> ${axiosError.code}
	<br><b>Felmeddelande:</b> ${axiosError.message}
</p>
`;
	}

	return errorTextHtml;
}
